import { SVGProps } from 'react';

export const ExtractIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 0 146 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M59 34.5746H27C15.9543 34.5746 7 43.5289 7 54.5746V118.575C7 129.62 15.9543 138.575 27 138.575H91C102.046 138.575 111 129.62 111 118.575V86.5746"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path d="M120.251 25.8237L53.749 92.3256" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path
        d="M135.731 0.224189C141.529 -1.15665 146.747 4.06123 145.366 9.85982L136.19 48.3921C134.741 54.4803 127.177 56.6211 122.751 52.1957L93.3948 22.8393C88.9694 18.4139 91.1102 10.8498 97.1984 9.40004L135.731 0.224189Z"
        fill="currentColor"
      />
    </svg>
  );
};
